(function () {
  'use strict';

  function node(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = String(text);
    return element;
  }

  // 出典は自社ストアへの転載記事なので媒体名を出さず、発表主体を見せる。
  function publisherLabel(member) {
    if (member && typeof member.issuer === 'string' && member.issuer) return '発表主体：' + member.issuer;
    return member && typeof member.source === 'string' ? member.source : '';
  }

  // 矢印は文字（←→）だと環境ごとに大きさと位置がぶれるため、図形で描く。
  function chevron(step) {
    var namespace = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(namespace, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS(namespace, 'path');
    path.setAttribute('d', step < 0 ? 'M15 4 L7 12 L15 20' : 'M9 4 L17 12 L9 20');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2.2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  function safeUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url : null;
    } catch (_) {
      return null;
    }
  }

  function previewUrl(value) {
    var url = safeUrl(value);
    if (!url) return null;
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview && url.origin === window.location.origin) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  }

  function articleDestination(item, config) {
    var previewMode = config.dataSource === 'preview';
    var candidates = [];
    if (item.published !== false) candidates.push(item.article_url);
    if (previewMode) candidates.push(item.preview_url);
    if (previewMode) candidates.push(item.review_url);
    if (!item.article_url && item.published !== false) candidates.push(item.url);
    var url = candidates.map(safeUrl).find(Boolean);
    if (!url) return null;
    var current = new URLSearchParams(window.location.search).get('preview_theme_id');
    var theme = current || config.previewThemeId;
    if (config.dataSource === 'preview' && /^\d+$/.test(theme || '') && url.origin === window.location.origin) url.searchParams.set('preview_theme_id', theme);
    return url.href;
  }

  function imageSource(item, config) {
    var url = safeUrl(item.image);
    if (!url && typeof item.image_asset === 'string' && /^[a-zA-Z0-9][a-zA-Z0-9_.-]*\.(?:png|jpe?g|webp|avif|gif)$/i.test(item.image_asset)) {
      var base = safeUrl(config.assetUrl);
      if (base) {
        url = new URL(item.image_asset, base);
        if (typeof item.image_version === 'string' && /^[a-f0-9]{16}$/.test(item.image_version)) url.searchParams.set('v', item.image_version);
      }
    }
    return url;
  }

  function setResponsiveImage(image, url, isHero, isCompany) {
    image.src = url.href;
    // Shopify article/files images support server-side width transforms. Theme
    // assets and arbitrary hosts keep their original URL instead of fake srcsets.
    if ((url.hostname === 'cdn.shopify.com' || url.origin === window.location.origin) && /\/s\/files\/.*\/(?:articles|files)\//.test(url.pathname)) {
      var widths = isHero ? [480, 720, 960, 1400] : [320, 480, 640, 960];
      image.srcset = widths.map(function (width) {
        var variant = new URL(url.href);
        variant.searchParams.set('width', String(width));
        return variant.href + ' ' + width + 'w';
      }).join(', ');
      var source = new URL(url.href);
      source.searchParams.set('width', isHero ? '960' : '640');
      image.src = source.href;
      image.sizes = isHero ? '(max-width: 900px) calc(100vw - 40px), 820px' : '(max-width: 639px) calc(100vw - 40px), (max-width: 989px) calc((100vw - 100px) / 2), 360px';
    }
  }

  function dateValue(value) {
    var date = new Date(value || '');
    return Number.isNaN(date.getTime()) ? 0 : date.getTime();
  }

  function formatDate(value) {
    var match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? match[1] + '.' + match[2] + '.' + match[3] : '';
  }

  function timeNode(value, className) {
    var element = node('time', className, formatDate(value));
    if (dateValue(value)) element.dateTime = String(value);
    return element;
  }

  function sortNewest(items) {
    return items.slice().sort(function (a, b) { return (dateValue(b.published_at) || dateValue(b.date)) - (dateValue(a.published_at) || dateValue(a.date)) || (Number(b.index) || 0) - (Number(a.index) || 0); });
  }

  function externalLink(value, title, className) {
    var href = previewUrl(value);
    var element = node(href ? 'a' : 'span', className, title);
    if (href) {
      element.href = href;
      element.target = '_blank';
      element.rel = 'noopener noreferrer';
      var arrow = node('span', '', '↗');
      arrow.setAttribute('aria-hidden', 'true');
      element.append(arrow, node('span', 'nm-sr-only', '（新しいタブで開く）'));
    }
    return element;
  }

  // Rebuild an inert parsed document from a strict allowlist. No HTML from the
  // feed is inserted directly, and active content and remote images are dropped.
  function safeArticleHtml(html, prefix) {
    var parsed = new DOMParser().parseFromString(String(html), 'text/html');
    var allowed = new Set(['P', 'H2', 'H3', 'H4', 'UL', 'OL', 'LI', 'SUP', 'STRONG', 'EM', 'B', 'I', 'BR', 'BLOCKQUOTE', 'DIV', 'SPAN', 'HR', 'A']);
    var blocked = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'SVG', 'MATH', 'TEMPLATE', 'FORM', 'INPUT', 'BUTTON', 'TEXTAREA', 'SELECT', 'LINK', 'META', 'IMG', 'VIDEO', 'AUDIO']);
    var fragment = document.createDocumentFragment();

    function copy(source, parent) {
      if (source.nodeType === 3) {
        parent.append(document.createTextNode(source.textContent));
        return;
      }
      if (source.nodeType !== 1 || blocked.has(source.tagName)) return;
      var destination = parent;
      if (allowed.has(source.tagName)) {
        destination = document.createElement(source.tagName.toLowerCase());
        var classes = Array.from(source.classList).filter(function (name) { return /^pnart-[a-z0-9_-]+$/.test(name); });
        if (classes.length) destination.className = classes.join(' ');
        var id = source.getAttribute('id');
        if (id && /^[a-zA-Z0-9_-]+$/.test(id)) destination.id = prefix + id;
        if (source.tagName === 'A') {
          var raw = source.getAttribute('href') || '';
          if (/^#[a-zA-Z0-9_-]+$/.test(raw)) {
            destination.href = '#' + prefix + raw.slice(1);
          } else {
            var href = previewUrl(raw);
            if (href) {
              destination.href = href;
              destination.target = '_blank';
              destination.rel = 'noopener noreferrer';
            }
          }
        }
        parent.append(destination);
      }
      Array.from(source.childNodes).forEach(function (child) { copy(child, destination); });
    }

    Array.from(parsed.body.childNodes).forEach(function (child) { copy(child, fragment); });
    return fragment;
  }

  function sourceList(members) {
    var list = node('ol', 'nm-source-list');
    sortNewest(members).forEach(function (member) {
      var item = node('li', 'nm-source-item');
      var content = node('div', 'nm-source-content');
      var title = member.title || '出典を読む';
      var link = externalLink(member.url, title, 'nm-source-link');
      if (Number.isInteger(member.index) && member.index > 0) {
        link.prepend(node('span', 'nm-source-index', '[' + member.index + ']'));
      }
      content.append(link);
      var memberPublisher = publisherLabel(member);
      if (memberPublisher) content.append(node('span', 'nm-source-publisher', memberPublisher));
      item.append(timeNode(member.date, 'nm-source-date'), content);
      list.append(item);
    });
    return list;
  }

  function visualFallback(item, order) {
    var visual = node('div', 'nm-card-visual nm-visual-fallback');
    visual.dataset.tone = String(order % 4);
    visual.setAttribute('aria-hidden', 'true');
    visual.append(
      node('span', 'nm-visual-label', 'NEWS COLLECTION'),
      node('span', 'nm-visual-category', item.category || 'IT・AI の動き'),
      node('span', 'nm-visual-footer', '関連ニュースをたどる')
    );
    return visual;
  }

  function featureCard(item, order, config) {
    var card = node('article', 'nm-card');
    if (typeof item.id === 'string') card.dataset.nmSeriesId = item.id;
    var members = Array.isArray(item.members) ? item.members.filter(function (member) { return member && typeof member === 'object'; }) : [];
    var imageUrl = imageSource(item, config);
    if (imageUrl) {
      var visual = node('div', 'nm-card-visual');
      var image = node('img');
      setResponsiveImage(image, imageUrl, false, false);
      image.alt = item.image_alt || '';
      image.width = 640;
      image.height = 360;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.addEventListener('error', function () { visual.replaceWith(visualFallback(item, order)); }, { once: true });
      visual.append(image);
      card.append(visual);
      if (item.image_note) card.append(node('p', 'nm-image-note', item.image_note));
    } else {
      card.append(visualFallback(item, order));
    }

    var content = node('div', 'nm-card-content');
    var meta = node('div', 'nm-card-meta');
    meta.append(node('span', 'nm-category', item.category || '特集'), timeNode(item.date, 'nm-date'));
    var title = node('h3', 'nm-card-title');
    var articleUrl = articleDestination(item, config);
    if (articleUrl) {
      var titleLink = node('a', '', item.title || 'ニュース特集');
      titleLink.href = articleUrl;
      titleLink.dataset.nmArticleKind = 'series';
      title.append(titleLink);
    } else title.textContent = item.title || 'ニュース特集';
    content.append(meta, title);
    if (item.description) content.append(node('p', 'nm-card-description', item.description));

    var foot = node('div', 'nm-card-foot');
    var stats = node('div', 'nm-card-stats');
    var count = node('span', 'nm-member-count');
    count.append(node('strong', '', Number.isInteger(item.member_count) ? item.member_count : members.length), document.createTextNode(' 件の出典'));
    stats.append(count);
    if (item.status === 'review' && item.published !== true) stats.append(node('span', 'nm-status', '編集確認用'));
    foot.append(stats);

    if (members.length) {
      var sources = node('details', 'nm-detail');
      sources.append(node('summary', '', '出典・タイムライン'), sourceList(members));
      foot.append(sources);
    }

    if (item.html && !articleUrl) {
      var details = node('details', 'nm-detail nm-body-details');
      details.append(node('summary', '', articleUrl ? '特集の本文を読む' : '特集の本文を開く'));
      if (item.status === 'review') {
        details.append(node('p', 'nm-review-note', '検証用の下書きです。公開前に、本文の事実関係と出典の対応を確認してください。'));
      }
      var body = node('div', 'nm-richtext');
      body.append(safeArticleHtml(item.html, 'nm-' + config.sectionId + '-' + order + '-'));
      details.append(body);
      foot.append(details);
    }

    if (articleUrl) {
      var readMore = node('a', 'nm-card-link', '特集を読む');
      readMore.href = articleUrl;
      readMore.dataset.nmArticleKind = 'series';
      var arrow = node('span', '', '→');
      arrow.setAttribute('aria-hidden', 'true');
      readMore.append(arrow);
      foot.append(readMore);
    }
    content.append(foot);
    card.append(content);
    return card;
  }

  function newsItem(item, order) {
    var article = node('article', 'nm-news-item');
    var number = node('span', 'nm-news-number', String(order + 1).padStart(2, '0'));
    number.setAttribute('aria-hidden', 'true');
    var content = node('div');
    var meta = node('div', 'nm-card-meta');
    meta.append(node('span', 'nm-category', item.category || 'ニュース'), timeNode(item.date, 'nm-date'));
    var title = node('h3', 'nm-card-title');
    title.append(externalLink(item.url, item.title || 'ニュースを読む', ''));
    content.append(meta, title);
    if (item.description) content.append(node('p', 'nm-card-description', item.description));
    var itemPublisher = publisherLabel(item);
    if (itemPublisher) content.append(node('span', 'nm-source-publisher', itemPublisher));
    article.append(number, content);
    return article;
  }

  function normaliseSearch(value) {
    return (typeof value === 'string' ? value : '').normalize('NFKC').toLocaleLowerCase('ja').trim();
  }

  // Category labels determine one topic. Unknown categories remain accessible
  // through all features; source text never silently reclassifies an article.
  function topicForCategory(value) {
    var category = normaliseSearch(value);
    if (/^(?:ai(?:\b|・|活用|導入)|生成ai|人工知能)/.test(category)) return 'ai';
    if (/開発|プログラミング|エンジニア|セキュリティ|クラウド|インフラ|ソフトウェア|ハードウェア|ガジェット|通信|ロボット|ネットワーク|データ|技術|システム|security|develop|programming|cloud|infrastructure|devops|hardware|gadget|robotics|network|\bit\b/.test(category)) return 'development';
    if (/経営|マーケティング|マーケ|広告|営業|ビジネス|企業|戦略|組織|経済|人事|採用|marketing|business|management|sales|\bhr\b/.test(category)) return 'business';
    if (/\bai\b|人工知能|業務|効率化|自動化|働き方|研修|人材育成|リスキリング|教育|学習|\bdx\b|仕事|work/.test(category)) return 'ai';
    return '';
  }

  function plainParagraphs(value, className) {
    var fragment = document.createDocumentFragment();
    if (typeof value !== 'string') return fragment;
    value.split(/\n\s*\n|\n/).filter(function (text) { return text.trim(); }).forEach(function (text) {
      fragment.append(node('p', className || '', text));
    });
    return fragment;
  }

  function companyTopics(company) {
    var list = node('ul', 'nm-company-topics');
    list.setAttribute('aria-label', 'この企業のテーマ');
    (Array.isArray(company.topics) ? company.topics : []).filter(function (topic) { return typeof topic === 'string' && topic; }).forEach(function (topic) {
      list.append(node('li', '', topic));
    });
    return list;
  }

  function companyMemberTime(member) {
    return dateValue(member.published_at) || dateValue(member.date);
  }

  function sortCompanyMembers(members) {
    return members.slice().sort(function (a, b) {
      return companyMemberTime(b) - companyMemberTime(a) || (Number(b.index) || 0) - (Number(a.index) || 0);
    });
  }

  function latestCompanyTime(company) {
    var latest = company.members.reduce(function (value, member) { return Math.max(value, dateValue(member.published_at)); }, 0);
    if (latest) return latest;
    return company.members.reduce(function (value, member) { return Math.max(value, dateValue(member.date)); }, dateValue(company.date));
  }

  function companyCoverage(company) {
    var meta = node('div', 'nm-company-meta');
    var count = Number.isInteger(company.article_count) && company.article_count >= 0 ? company.article_count : company.members.length;
    var countText = node('span', 'nm-company-article-count');
    countText.append(node('strong', '', count), document.createTextNode('件の発表記事'));
    meta.append(countText);
    var start = formatDate(company.coverage_start);
    var end = formatDate(company.coverage_end);
    if (start || end) meta.append(node('span', 'nm-company-period', '掲載 ' + (start && end && start !== end ? start + ' — ' + end : start || end)));
    return meta;
  }

  function companyImage(company, config, isHero) {
    var url = imageSource(company, config);
    if (!url) return null;
    var frame = node('div', isHero ? 'nm-company-hero' : 'nm-company-card-image');
    var image = node('img');
    setResponsiveImage(image, url, isHero, true);
    image.alt = typeof company.image_alt === 'string' && company.image_alt.trim() ? company.image_alt : (typeof company.image_copy === 'string' && company.image_copy ? company.image_copy + '。' : '') + (company.name || company.legal_name || '企業') + 'の取り組みを表すイラスト';
    image.width = 1600;
    image.height = 900;
    image.loading = isHero ? 'eager' : 'lazy';
    image.decoding = 'async';
    image.addEventListener('error', function () { frame.remove(); }, { once: true });
    frame.append(image);
    return frame;
  }

  function followLocalLink(link, action) {
    link.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      action();
    });
    return link;
  }

  function focusAndScroll(element) {
    if (!element) return;
    if (!element.hasAttribute('tabindex')) element.tabIndex = -1;
    element.focus({ preventScroll: true });
    element.scrollIntoView({ block: 'start', behavior: 'auto' });
  }

  function init(section) {
    if (section.dataset.nmInitialized) return;
    section.dataset.nmInitialized = 'true';
    var panel = section.querySelector('[data-nm-panel]');
    var filters = section.querySelector('[data-nm-filters]');
    var resultCount = section.querySelector('[data-nm-result-count]');
    var tabs = Array.from(section.querySelectorAll('[data-nm-tab]'));
    var tabList = section.querySelector('[role="tablist"]');
    var initialLinks = panel.querySelector('[data-nm-ssr]');
    var searchInput = section.querySelector('[data-nm-search]');
    var searchClear = section.querySelector('[data-nm-search-clear]');
    var searchHint = section.querySelector('[data-nm-search-hint]');
    var searchLabel = section.querySelector('[data-nm-search-label]');
    var searchIndex = new WeakMap();
    var config;
    var data = { series: [], news: [], companies: [] };
    var state = { tab: 'series', category: '', query: '', terms: [], companyId: '', featureId: '', page: 1, ready: false };
    // サイドピークは一覧ハブと同じ共有モジュール。URLパラメータ ?nm_peek= が状態源で、
    // TOPの routeUrl は未知パラメータを消さないため履歴の書き換えと共存できる。
    var peek = window.NewsMatomePeek ? window.NewsMatomePeek.controller({ analytics: section.dataset.nmPeekAnalytics === 'true' }) : null;
    var composing = false;
    var previewThemeId = '';
    var analyticsTimer;
    var cardScroll = null;
    var cardScrollObserver;
    var cardScrollFrame;
    var showcaseStage;
    var showcaseButtons = [];
    var showcaseArchive;

    function track(action, extra) {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!config.analyticsEvents || !privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
      try { if (!privacy.analyticsProcessingAllowed()) return; } catch (_) { return; }
      // This local event has no query, category text, title, URL, or visitor ID.
      // A separately configured, consent-aware listener may aggregate it.
      var detail = Object.assign({ action: action, tab: state.tab, has_query: Boolean(state.query) }, extra || {});
      section.dispatchEvent(new CustomEvent('news-matome:analytics', { bubbles: true, detail: detail }));
    }

    function tabItems(tabKey) {
      if (tabKey === 'news') return config.showNews === false || config.homeShowcase ? [] : data.news;
      if (tabKey === 'companies') return data.companies;
      if (tabKey === 'series') return data.series;
      return data.series.filter(function (item) { return topicForCategory(item.category) === tabKey; });
    }

    function matchesSearch(item) {
      var text = searchIndex.get(item) || '';
      return state.terms.every(function (term) { return text.includes(term); });
    }

    function visibleTabs() {
      return tabs.filter(function (tab) { return !tab.hidden; });
    }

    function syncTabs() {
      tabs.forEach(function (tab) {
        var items = tabItems(tab.dataset.nmTab);
        // Visibility depends on source data, not transient search results.
        var hasContent = data.series.length || data.companies.length || (config.showNews !== false && !config.homeShowcase && data.news.length);
        tab.hidden = (tab.dataset.nmTab === 'news' && (config.showNews === false || config.homeShowcase)) || (!items.length && !(tab.dataset.nmTab === 'series' && !hasContent));
        tab.disabled = !state.ready;
        tab.querySelector('[data-nm-tab-count]').textContent = String(items.filter(matchesSearch).length) + (tab.dataset.nmTab === 'companies' ? '社' : '');
      });
      var selected = tabs.find(function (tab) { return tab.dataset.nmTab === state.tab && !tab.hidden; });
      if (!selected) {
        selected = visibleTabs()[0];
        state.tab = selected.dataset.nmTab;
        state.category = '';
        state.page = 1;
        state.featureId = '';
        if (state.tab !== 'companies') state.companyId = '';
      }
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', String(tab === selected));
        tab.tabIndex = tab === selected ? 0 : -1;
      });
      panel.setAttribute('aria-labelledby', selected.id);
    }

    function routeUrl(tab, companyId, featureId, pageNumber) {
      var url = new URL(window.location.href);
      if (previewThemeId && !url.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', previewThemeId);
      url.searchParams.set('nm_tab', tab);
      if (companyId) url.searchParams.set('nm_company', companyId);
      else url.searchParams.delete('nm_company');
      if (featureId) url.searchParams.set('nm_series', featureId);
      else url.searchParams.delete('nm_series');
      if (state.query) url.searchParams.set('q', state.query);
      else url.searchParams.delete('q');
      if (state.category) url.searchParams.set('category', state.category);
      else url.searchParams.delete('category');
      var currentPage = pageNumber || state.page;
      if (currentPage > 1) url.searchParams.set('nm_page', String(currentPage));
      else url.searchParams.delete('nm_page');
      if (url.hash.indexOf('#nm-') === 0) url.hash = '';
      return url.href;
    }

    function writeHistory(mode, url) {
      var current = window.history.state;
      var next = Object.assign({}, current && typeof current === 'object' ? current : {});
      var saved = Object.assign({}, next.newsMatome || {});
      saved[config.sectionId] = { tab: state.tab, companyId: state.companyId, featureId: state.featureId, query: state.query, category: state.category, page: state.page };
      next.newsMatome = saved;
      window.history[mode === 'push' ? 'pushState' : 'replaceState'](next, '', url || window.location.href);
    }

    function setSearchValue(value) {
      searchInput.value = typeof value === 'string' ? value.slice(0, 160) : '';
      state.query = searchInput.value.trim();
      state.terms = normaliseSearch(state.query).split(/\s+/).filter(Boolean);
      searchClear.hidden = !searchInput.value;
    }

    function focusRoute() {
      if (state.companyId) {
        var fragmentId = '';
        try { fragmentId = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { /* A malformed fragment is ignored. */ }
        var fragmentTarget = fragmentId ? document.getElementById(fragmentId) : null;
        focusAndScroll(fragmentTarget && panel.contains(fragmentTarget) ? fragmentTarget : panel.querySelector('.nm-company-detail-title') || panel);
      }
      else if (state.featureId) {
        var card = Array.from(panel.querySelectorAll('[data-nm-series-id]')).find(function (item) { return item.dataset.nmSeriesId === state.featureId; });
        if (card) {
          var body = card.querySelector('.nm-body-details');
          if (body) body.open = true;
          focusAndScroll(card.querySelector('.nm-card-title, .nm-showcase-title') || card);
        }
      }
    }

    function renderRoute() {
      syncTabs();
      renderFilters();
      render();
      syncShowcaseArchive();
      var selected = tabs.find(function (tab) { return tab.dataset.nmTab === state.tab; });
      if (selected) revealTab(selected);
    }

    function navigate(tab, companyId, featureId, options) {
      if (!state.ready) return;
      options = options || {};
      writeHistory('replace');
      state.tab = tab;
      state.companyId = companyId || '';
      state.featureId = featureId || '';
      state.category = '';
      state.page = 1;
      if (options.clearSearch) setSearchValue('');
      var url = routeUrl(state.tab, state.companyId, state.featureId);
      renderRoute();
      writeHistory(url === window.location.href ? 'replace' : 'push', url);
      if (options.focus !== false) {
        if (state.companyId || state.featureId) focusRoute();
        else focusAndScroll(panel);
      }
      track(companyId ? 'company_open' : featureId ? 'series_open' : 'tab_select');
    }

    function restoreLocation(shouldFocus) {
      if (!state.ready) return;
      var params = new URLSearchParams(window.location.search);
      var requested = params.get('nm_tab');
      state.tab = tabs.some(function (tab) { return tab.dataset.nmTab === requested; }) ? requested : 'series';
      state.companyId = state.tab === 'companies' ? params.get('nm_company') || '' : '';
      state.featureId = state.tab === 'series' ? params.get('nm_series') || '' : '';
      var historyState = window.history.state;
      var saved = historyState && historyState.newsMatome && historyState.newsMatome[config.sectionId];
      var matchesRoute = saved && saved.tab === state.tab && saved.companyId === state.companyId && saved.featureId === state.featureId;
      state.category = params.has('category') ? params.get('category').slice(0, 120) : matchesRoute ? saved.category || '' : '';
      setSearchValue(params.has('q') ? params.get('q') : matchesRoute ? saved.query : '');
      var requestedPage = params.has('nm_page') ? Number(params.get('nm_page')) : matchesRoute ? Number(saved.page) : 1;
      state.page = Number.isInteger(requestedPage) && requestedPage > 0 && requestedPage < 100000 ? requestedPage : 1;
      // 共有された ?nm_peek= があるときはピークを優先し、旧来の深リンク転送は行わない。
      if (params.get('nm_peek')) { state.companyId = ''; state.featureId = ''; }
      var migrated = state.companyId ? data.companies.find(function (item) { return item.id === state.companyId; }) : state.featureId ? data.series.find(function (item) { return item.id === state.featureId; }) : null;
      var destination = migrated && articleDestination(migrated, config);
      if (destination && new URL(destination).href !== window.location.href) {
        window.location.replace(destination);
        return;
      }
      if (config.homeShowcase) {
        setSearchValue('');
        state.category = '';
        state.page = 1;
      }
      renderRoute();
      if ((config.homeShowcase && (params.has('q') || params.has('category') || params.has('nm_page'))) || (requested && requested !== state.tab) || (params.has('nm_page') && Number(params.get('nm_page')) !== state.page)) {
        writeHistory('replace', routeUrl(state.tab, state.companyId, state.featureId));
      }
      if (shouldFocus || state.companyId || state.featureId) {
        if (state.companyId || state.featureId) focusRoute();
        else focusAndScroll(panel);
      }
    }

    function revealTab(tab) {
      var left = tab.getBoundingClientRect().left - tabList.getBoundingClientRect().left + tabList.scrollLeft;
      var right = left + tab.offsetWidth;
      if (left < tabList.scrollLeft + 8) tabList.scrollLeft = Math.max(0, left - 8);
      else if (right > tabList.scrollLeft + tabList.clientWidth - 8) tabList.scrollLeft = right - tabList.clientWidth + 8;
    }

    function clearConditions() {
      state.category = '';
      searchInput.value = '';
      updateSearch();
      searchInput.focus({ preventScroll: true });
    }

    function empty(title, description, retry) {
      var box = node('div', 'nm-empty');
      box.append(node('span', 'nm-empty-title', title), node('p', '', description));
      if (retry) {
        var button = node('button', 'nm-retry', 'もう一度読み込む');
        button.type = 'button';
        button.addEventListener('click', load);
        box.append(button);
      }
      return box;
    }

    function companyLink(company, text, className) {
      var link = node('a', className, text);
      var destination = articleDestination(company, config);
      if (destination) {
        link.href = destination;
        link.dataset.nmArticleKind = 'company';
        return link;
      }
      link.href = routeUrl('companies', company.id, '');
      return followLocalLink(link, function () { navigate('companies', company.id); });
    }

    function companyBackLink() {
      var link = node('a', 'nm-company-back', '← 企業一覧へ戻る');
      link.href = routeUrl('companies', '', '');
      return followLocalLink(link, function () { navigate('companies'); });
    }

    function companyCard(company) {
      var card = node('article', 'nm-company-card');
      card.dataset.nmCompanyId = company.id;
      var image = companyImage(company, config, false);
      if (image) card.append(image);
      var content = node('div', 'nm-company-card-content');
      content.append(node('p', 'nm-company-name', company.name || company.legal_name));
      var heading = node('h3', 'nm-company-card-title');
      heading.append(companyLink(company, company.title, ''));
      content.append(heading, node('p', 'nm-company-card-description', company.description), companyTopics(company));
      var footer = node('div', 'nm-company-card-footer');
      footer.append(companyCoverage(company));
      var more = companyLink(company, '企業のまとめを読む', 'nm-company-read');
      more.setAttribute('aria-label', (company.name || company.legal_name) + 'の企業まとめを読む');
      var arrow = node('span', '', '→');
      arrow.setAttribute('aria-hidden', 'true');
      more.append(arrow);
      footer.append(more);
      content.append(footer);
      card.append(content);
      return card;
    }

    function companyDetail(company) {
      var article = node('article', 'nm-company-detail');
      var prefix = 'nm-company-' + config.sectionId + '-' + company.id + '-';
      var members = sortCompanyMembers(company.members);
      var parts = (Array.isArray(company.sections) ? company.sections : []).filter(function (part) { return part && typeof part.text === 'string' && part.text.trim(); });
      var sourceMap = new Map();
      members.forEach(function (member) { if (Number.isInteger(member.index)) sourceMap.set(member.index, member); });
      article.append(companyBackLink());
      var header = node('header', 'nm-company-detail-header');
      header.append(node('p', 'nm-company-name', company.name || company.legal_name));
      if (company.legal_name && company.legal_name !== company.name) header.append(node('p', 'nm-company-legal-name', company.legal_name));
      var title = node('h3', 'nm-company-detail-title', company.title);
      title.id = prefix + 'title';
      title.tabIndex = -1;
      article.setAttribute('aria-labelledby', title.id);
      header.append(title);
      var hero = companyImage(company, config, true);
      if (hero) header.append(hero);
      header.append(node('p', 'nm-company-lead', company.description), companyTopics(company), companyCoverage(company));
      header.append(node('p', 'nm-company-provenance', 'trends.掲載の同社の発表をもとに構成'));
      article.append(header);

      var readingText = [company.description].concat(parts.map(function (part) { return part.text; })).filter(function (text) { return typeof text === 'string'; }).join('');
      if (readingText.trim()) {
        var minutes = Math.max(1, Math.ceil(Array.from(readingText.replace(/\s/g, '')).length / 500));
        article.append(node('p', 'nm-company-reading-time', '本文の目安 約' + minutes + '分'));
      }

      var headedParts = parts.map(function (part, index) { return { part: part, id: prefix + 'section-' + (index + 1) }; }).filter(function (entry) { return typeof entry.part.heading === 'string' && entry.part.heading.trim(); });
      if (headedParts.length > 1) {
        var contents = node('nav', 'nm-company-contents');
        contents.setAttribute('aria-label', 'この企業まとめの目次');
        contents.append(node('p', 'nm-company-contents-label', 'このまとめで読むこと'));
        var contentsList = node('ol');
        headedParts.forEach(function (entry) {
          var item = node('li');
          var link = node('a', '', entry.part.heading);
          link.href = '#' + entry.id;
          followLocalLink(link, function () { focusAndScroll(document.getElementById(entry.id)); });
          item.append(link);
          contentsList.append(item);
        });
        contents.append(contentsList);
        article.append(contents);
      }

      var editorial = node('div', 'nm-company-editorial');
      parts.forEach(function (part, index) {
        var block = node('section', 'nm-company-editorial-section');
        if (part.heading) {
          var sectionTitle = node('h4', '', part.heading);
          sectionTitle.id = prefix + 'section-' + (index + 1);
          sectionTitle.tabIndex = -1;
          block.setAttribute('aria-labelledby', sectionTitle.id);
          block.append(sectionTitle);
        }
        block.append(plainParagraphs(part.text));
        var indices = Array.isArray(part.source_indices) ? Array.from(new Set(part.source_indices)).filter(function (index) { return sourceMap.has(index); }) : [];
        if (indices.length) {
          var references = node('p', 'nm-company-citations');
          references.append(document.createTextNode('出典 '));
          indices.forEach(function (index) {
            var citation = node('a', '', '[' + index + ']');
            var targetId = prefix + 'source-' + index;
            citation.href = '#' + targetId;
            citation.setAttribute('aria-label', '出典' + index + '：' + sourceMap.get(index).title);
            followLocalLink(citation, function () { focusAndScroll(document.getElementById(targetId)); });
            references.append(citation);
          });
          block.append(references);
        }
        editorial.append(block);
      });
      article.append(editorial);

      var related = (Array.isArray(company.related_series) ? company.related_series : []).map(function (item) {
        return item && data.series.find(function (series) { return series.id === item.id; });
      }).filter(Boolean);
      if (related.length) {
        var relatedBlock = node('section', 'nm-company-related');
        var relatedHeading = node('h4', '', 'あわせて読みたい特集');
        relatedHeading.id = prefix + 'related';
        relatedBlock.setAttribute('aria-labelledby', relatedHeading.id);
        relatedBlock.append(relatedHeading);
        var relatedList = node('ul');
        related.forEach(function (series) {
          var item = node('li');
          var link = node('a', 'nm-company-related-link', series.title);
          var destination = articleDestination(series, config);
          link.href = destination || routeUrl('series', '', series.id);
          var arrow = node('span', '', '→');
          arrow.setAttribute('aria-hidden', 'true');
          link.append(arrow);
          if (!destination) followLocalLink(link, function () { navigate('series', '', series.id, { clearSearch: true }); });
          item.append(link);
          relatedList.append(item);
        });
        relatedBlock.append(relatedList);
        article.append(relatedBlock);
      }

      var timeline = node('section', 'nm-company-timeline');
      var timelineHeader = node('div', 'nm-company-timeline-heading');
      var timelineTitle = node('h4', '', '発表記事のタイムライン');
      timelineTitle.id = prefix + 'timeline';
      timeline.setAttribute('aria-labelledby', timelineTitle.id);
      timelineHeader.append(timelineTitle, node('span', '', '掲載の新しい順'));
      timeline.append(timelineHeader);
      var list = node('ol', 'nm-source-list nm-company-source-list');
      members.forEach(function (member) {
        var item = node('li', 'nm-source-item nm-company-source');
        if (Number.isInteger(member.index)) item.id = prefix + 'source-' + member.index;
        item.tabIndex = -1;
        var meta = node('div', 'nm-company-source-meta');
        if (Number.isInteger(member.index)) meta.append(node('span', 'nm-company-source-index', '[' + member.index + ']'));
        meta.append(document.createTextNode('掲載 '), timeNode(member.date, 'nm-source-date'));
        var heading = node('h5', 'nm-company-source-title');
        heading.append(externalLink(member.url, member.title || '出典を読む', 'nm-source-link'));
        item.append(meta, heading);
        item.append(plainParagraphs(member.summary, 'nm-company-source-summary'));
        var sourcePublisher = publisherLabel(member);
        if (sourcePublisher) item.append(node('span', 'nm-source-publisher', sourcePublisher));
        list.append(item);
      });
      if (members.length) timeline.append(list);
      else timeline.append(node('p', 'nm-company-provenance', '発表記事はまだ登録されていません。'));
      article.append(timeline, companyBackLink());
      return article;
    }

    function renderFilters() {
      if (config.homeShowcase || state.tab === 'companies') {
        state.category = '';
        filters.hidden = true;
        filters.replaceChildren();
        return;
      }
      var categories = Array.from(new Set(tabItems(state.tab).map(function (item) { return item.category; }).filter(function (category) { return typeof category === 'string' && category; })));
      filters.hidden = categories.length < 2;
      if (filters.hidden || (state.category && !categories.includes(state.category))) state.category = '';
      var fragment = document.createDocumentFragment();
      [''].concat(categories).forEach(function (category) {
        var button = node('button', 'nm-filter', category || 'すべてのカテゴリ');
        button.type = 'button';
        button.setAttribute('aria-pressed', String(state.category === category));
        button.addEventListener('click', function () {
          state.category = category;
          state.featureId = '';
          state.page = 1;
          Array.from(filters.children).forEach(function (child) { child.setAttribute('aria-pressed', String(child === button)); });
          render();
          writeHistory('replace', routeUrl(state.tab, '', ''));
          track('category_filter');
        });
        fragment.append(button);
      });
      filters.replaceChildren(fragment);
    }

    function syncShowcaseArchive() {
      if (!config.homeShowcase) return;
      section.querySelectorAll('[data-nm-archive]').forEach(function (link) {
        var url = safeUrl(link.dataset.nmArchiveBase || link.getAttribute('href'));
        if (!url) return;
        url.pathname = '/blogs/media/news-matome';
        if (state.tab === 'series') url.searchParams.delete('view');
        else url.searchParams.set('view', 'news-matome-' + state.tab);
        url.searchParams.set('nm_tab', state.tab);
        url.searchParams.delete('nm_company');
        url.searchParams.delete('nm_series');
        url.searchParams.delete('nm_page');
        url.searchParams.delete('q');
        url.searchParams.delete('category');
        var theme = new URLSearchParams(window.location.search).get('preview_theme_id') || previewThemeId;
        if (/^\d+$/.test(theme || '') && url.origin === window.location.origin) url.searchParams.set('preview_theme_id', theme);
        link.href = url.href;
        var labels = { series: 'すべての特集を見る', companies: '企業のまとめをすべて見る', ai: 'AI・業務活用の特集をすべて見る', development: '技術・開発の特集をすべて見る', business: '経営・マーケティングの特集をすべて見る' };
        link.textContent = labels[state.tab] || labels.series;
      });
    }

    function prepareShowcaseStage() {
      if (showcaseStage) return;
      showcaseArchive = section.querySelector('[data-nm-archive]');
      showcaseStage = node('div', 'nm-showcase-stage');
      showcaseStage.dataset.nmShowcaseStage = '';
      panel.before(showcaseStage);
      showcaseStage.append(panel);
      [-1, 1].forEach(function (step) {
        var button = node('button', 'nm-showcase-switch');
        button.appendChild(chevron(step));
        button.type = 'button';
        button.dataset[step < 0 ? 'nmShowcasePrev' : 'nmShowcaseNext'] = '';
        button.setAttribute('aria-label', step < 0 ? '前のテーマを表示' : '次のテーマを表示');
        if (panel.id) button.setAttribute('aria-controls', panel.id);
        button.hidden = true;
        button.addEventListener('click', function () {
          var available = visibleTabs();
          if (!state.ready || available.length < 2) return;
          var index = available.findIndex(function (tab) { return tab.dataset.nmTab === state.tab; });
          var target = available[(index + step + available.length) % available.length];
          showcaseStage.style.setProperty('--nm-carousel-direction', (step * 18) + 'px');
          navigate(target.dataset.nmTab, '', '', { focus: false, clearSearch: true });
          revealActiveTab();
          // These controls are outside the replaced tabpanel, preserving focus.
          button.focus({ preventScroll: true });
          track('showcase_change');
        });
        showcaseButtons.push(button);
        showcaseStage.append(button);
      });
    }

    function showcaseCard(item, isCompanies, isHero) {
      var card = node('article', isHero ? 'nm-showcase-hero' : 'nm-showcase-secondary');
      if (isHero) card.dataset.nmShowcaseHero = '';
      if (isCompanies) card.dataset.nmCompanyId = item.id;
      else card.dataset.nmSeriesId = item.id;
      var destination = articleDestination(item, config);
      var media = node(destination ? 'a' : 'div', 'nm-showcase-media');
      if (destination) { media.href = destination; media.dataset.nmArticleKind = isCompanies ? 'company' : 'series'; media.setAttribute('aria-label', item.title); }
      var imageUrl = imageSource(item, config);
      if (imageUrl) {
        var image = node('img');
        setResponsiveImage(image, imageUrl, isHero, false);
        if (image.srcset && isHero) image.sizes = '(max-width: 749px) calc(100vw - 40px), (max-width: 1240px) calc((100vw - 116px) * 0.6), 680px';
        image.alt = item.image_alt || '';
        image.width = 960;
        image.height = 540;
        image.loading = isHero ? 'eager' : 'lazy';
        image.decoding = 'async';
        if (isHero) image.fetchPriority = 'high';
        image.addEventListener('error', function () { media.replaceChildren(node('span', 'nm-showcase-image-fallback', isCompanies ? item.name || '企業の取り組み' : item.category || 'ニュース特集')); }, { once: true });
        media.append(image);
      } else media.append(node('span', 'nm-showcase-image-fallback', isCompanies ? item.name || '企業の取り組み' : item.category || 'ニュース特集'));
      card.append(media);
      var content = node('div', 'nm-showcase-copy');
      content.append(node('p', 'nm-showcase-category', isCompanies ? item.name || item.legal_name : item.category || '特集'));
      var heading = node('h3', 'nm-showcase-title');
      if (isCompanies) heading.append(companyLink(item, item.title, ''));
      else if (destination) {
        var titleLink = node('a', '', item.title);
        titleLink.href = destination;
        titleLink.dataset.nmArticleKind = 'series';
        heading.append(titleLink);
      } else heading.textContent = item.title;
      content.append(heading);
      if (isHero) content.append(node('p', 'nm-showcase-description', item.description || ''));
      var members = (Array.isArray(item.members) ? item.members : []).filter(function (member) { return member && typeof member.title === 'string'; });
      var count = isCompanies && Number.isInteger(item.article_count) ? item.article_count : Number.isInteger(item.member_count) ? item.member_count : members.length;
      content.append(node('p', 'nm-showcase-source-count', count + '件の出典をもとに'));
      if (isHero) {
        var sources = node('ul', 'nm-showcase-sources');
        if (members.length) sources.setAttribute('aria-label', 'このまとめの出典');
        sortNewest(members).slice(0, 2).forEach(function (member) {
          var entry = node('li');
          entry.append(externalLink(member.url, member.title, 'nm-source-link'));
          sources.append(entry);
        });
        content.append(sources);
      }
      var action = isHero ? node('div', 'nm-showcase-action') : null;
      if (isHero && (destination || isCompanies)) {
        var more = isCompanies ? companyLink(item, '企業のまとめを読む', 'nm-showcase-read') : node('a', 'nm-showcase-read', '特集を読む');
        if (!isCompanies) { more.href = destination; more.dataset.nmArticleKind = 'series'; }
        action.append(more);
      } else if (isHero && item.html) {
        var legacy = node('a', 'nm-showcase-read', '特集の本文を読む');
        legacy.href = routeUrl('series', '', item.id, 1);
        legacy.addEventListener('click', function (event) {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          navigate('series', '', item.id);
        });
        action.append(legacy);
      }
      if (action) content.append(action);
      card.append(content);
      return card;
    }

    function renderShowcase(items, isCompanies) {
      state.page = 1;
      prepareShowcaseStage();
      showcaseStage.classList.add('nm-showcase-stage--ready');
      showcaseStage.dataset.nmActiveTab = state.tab;
      var available = visibleTabs();
      showcaseButtons.forEach(function (button) { button.hidden = available.length < 2; });
      if (!items.length) {
        panel.replaceChildren(empty(isCompanies ? '企業のまとめはまだありません' : '特集はまだありません', '記事が追加されると、ここに表示されます。'));
        resultCount.textContent = '0件';
        panel.dataset.nmResultTotal = '0';
        addPanelHeading();
        panel.setAttribute('aria-busy', 'false');
        return;
      }
      var layout = node('div', 'nm-showcase-layout');
      layout.dataset.nmShowcase = '';
      layout.append(showcaseCard(items[0], isCompanies, true));
      var next = node('div', 'nm-showcase-next-list');
      next.dataset.nmShowcaseNextList = '';
      next.append(node('p', 'nm-showcase-next-heading', items.length > 1 ? '続けて読む' : ''));
      var rows = node('div', 'nm-showcase-next-rows');
      rows.dataset.nmShowcaseRows = '';
      items.slice(1, 4).forEach(function (item) { rows.append(showcaseCard(item, isCompanies, false)); });
      next.append(rows);
      var footer = node('div', 'nm-showcase-footer');
      footer.append(node('p', 'nm-showcase-total', 'このテーマのまとめ ' + items.length + (isCompanies ? '社' : '件')));
      if (showcaseArchive) footer.append(showcaseArchive);
      next.append(footer);
      layout.append(next);
      panel.replaceChildren(layout);
      panel.dataset.nmResultTotal = String(items.length);
      var selected = available.find(function (tab) { return tab.dataset.nmTab === state.tab; });
      var label = selected ? selected.firstChild.textContent : '特集';
      resultCount.textContent = label + '、' + items.length + (isCompanies ? '社' : '件') + '。先頭' + Math.min(items.length, 4) + '件を表示';
      addPanelHeading();
      panel.setAttribute('aria-busy', 'false');
    }

    function scrollCardLimit() {
      var value = Number(config.scrollCards);
      return Number.isFinite(value) && value > 0 ? Math.min(12, Math.floor(value)) : 0;
    }

    function clearCardScroll() {
      if (cardScrollObserver) cardScrollObserver.disconnect();
      window.cancelAnimationFrame(cardScrollFrame);
      cardScrollObserver = null;
      cardScroll = null;
    }

    function sizeCardScroll() {
      var current = cardScroll;
      if (!current || !current.wrapper.isConnected) return;
      var width = current.grid.getBoundingClientRect().width;
      if (!width) return;
      var columns = getComputedStyle(current.grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
      var visibleCount = Math.ceil(scrollCardLimit() / columns) * columns;
      // Measure a bounded, inert copy with details closed. Expanding a source
      // timeline must never increase the viewport's height, including on resize.
      var measure = node('div', current.grid.className + ' nm-card-measure');
      measure.style.width = width + 'px';
      measure.setAttribute('aria-hidden', 'true');
      measure.inert = true;
      Array.from(current.grid.children).slice(0, visibleCount).forEach(function (card) {
        var copy = card.cloneNode(true);
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(function (element) { element.removeAttribute('id'); });
        copy.querySelectorAll('details').forEach(function (details) { details.open = false; });
        copy.querySelectorAll('img').forEach(function (image) { image.removeAttribute('src'); image.removeAttribute('srcset'); image.alt = ''; });
        measure.append(copy);
      });
      current.wrapper.append(measure);
      var height = Math.ceil(measure.getBoundingClientRect().height) + 2;
      measure.remove();
      if (window.innerWidth <= 639) height = Math.min(height, Math.max(180, Math.floor(window.innerHeight * 0.8)));
      current.wrapper.style.maxHeight = height + 'px';
      current.wrapper.dataset.nmScrollReady = 'true';
    }

    function scheduleCardScroll() {
      if (!cardScroll) return;
      window.cancelAnimationFrame(cardScrollFrame);
      cardScrollFrame = window.requestAnimationFrame(sizeCardScroll);
    }

    function wrapCardGrid(grid, isCompanies) {
      var wrapper = node('div', 'nm-card-scroll');
      wrapper.dataset.nmCardScroll = '';
      wrapper.dataset.nmScrollReady = 'false';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', isCompanies ? '企業のカード一覧' : '特集のカード一覧');
      wrapper.append(grid);
      cardScroll = { wrapper: wrapper, grid: grid };
      wrapper.addEventListener('load', scheduleCardScroll, true);
      wrapper.addEventListener('error', scheduleCardScroll, true);
      if (typeof ResizeObserver !== 'undefined') {
        var previousWidth = -1;
        cardScrollObserver = new ResizeObserver(function () {
          var width = wrapper.clientWidth;
          if (Math.abs(width - previousWidth) > 0.5) { previousWidth = width; scheduleCardScroll(); }
        });
        cardScrollObserver.observe(wrapper);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
        if (cardScroll && cardScroll.wrapper === wrapper) scheduleCardScroll();
      });
      scheduleCardScroll();
      return wrapper;
    }

    function render() {
      clearCardScroll();
      if (showcaseStage) {
        showcaseStage.classList.remove('nm-showcase-stage--ready');
        showcaseButtons.forEach(function (button) { button.hidden = true; });
      }
      var isCompanies = state.tab === 'companies';
      searchInput.placeholder = isCompanies ? '一覧から企業を探す' : config.showNews === false ? '一覧からテーマを探す' : '一覧からテーマやニュースを探す';
      if (searchLabel) searchLabel.textContent = isCompanies ? '企業一覧を検索' : config.showNews === false ? '特集一覧を検索' : '特集・ニュース一覧を検索';
      if (searchHint) searchHint.textContent = isCompanies ? '企業名・製品・テーマ・概要・出典タイトルが対象です。本文内の検索ではありません。' : 'この一覧のタイトル・概要・出典タイトルが対象です。';
      if (isCompanies && state.companyId) {
        var company = data.companies.find(function (item) { return item.id === state.companyId; });
        if (company) {
          resultCount.textContent = (company.name || company.legal_name) + 'のまとめ';
          panel.replaceChildren(companyDetail(company));
        } else {
          resultCount.textContent = '企業のまとめが見つかりませんでした';
          var missing = empty('指定した企業のまとめが見つかりません', '企業一覧から、読みたいまとめを選んでください。');
          missing.append(companyBackLink());
          panel.replaceChildren(missing);
        }
        addPanelHeading();
        panel.setAttribute('aria-busy', 'false');
        return;
      }
      var items = tabItems(state.tab).filter(function (item) { return (!state.category || item.category === state.category) && matchesSearch(item); });
      if (config.homeShowcase) {
        if (state.featureId) {
          var featured = items.find(function (item) { return item.id === state.featureId; });
          if (featured) {
            // Old unpublished bodies remain readable outside the fixed preview.
            panel.replaceChildren(featureCard(featured, 0, config));
            addPanelHeading();
            panel.setAttribute('aria-busy', 'false');
            return;
          }
        }
        renderShowcase(items, isCompanies);
        return;
      }
      var scrollMode = state.tab !== 'news' && scrollCardLimit() > 0;
      var limit = Number(config.limit);
      var targetIndex = state.featureId ? items.findIndex(function (item) { return item.id === state.featureId; }) : -1;
      var pageSize = limit > 0 ? limit : 12;
      var pageCount = scrollMode || limit > 0 ? 1 : Math.max(1, Math.ceil(items.length / pageSize));
      state.page = Math.min(state.page, pageCount);
      if (!scrollMode && targetIndex >= 0 && !limit) state.page = Math.floor(targetIndex / pageSize) + 1;
      var start = (state.page - 1) * pageSize;
      var shown = scrollMode ? items : items.slice(start, limit > 0 ? Math.max(limit, targetIndex + 1) : start + pageSize);
      var unit = isCompanies ? '社' : '件';
      resultCount.textContent = (state.query ? '「' + state.query + '」の検索結果 · ' : '') + items.length + unit + (shown.length < items.length ? 'のうち' + (start + 1) + '〜' + (start + shown.length) + unit + 'を表示' : 'を表示');
      panel.dataset.nmResultTotal = String(items.length);
      var isNews = state.tab === 'news';
      var container = node('div', isCompanies ? 'nm-company-grid' : isNews ? 'nm-news-list' : 'nm-grid');
      shown.forEach(function (item, order) {
        container.append(isCompanies ? companyCard(item) : isNews ? newsItem(item, order) : featureCard(item, order, config));
      });
      if (!shown.length) {
        var hasConditions = state.category || state.query;
        var message = empty('該当する' + (isCompanies ? '企業' : isNews ? 'ニュース' : '特集') + 'はありません', hasConditions ? 'キーワードやカテゴリを変更するか、別のタブをご覧ください。' : (isCompanies ? '企業のまとめ' : isNews ? 'ニュース' : '特集') + 'が追加されると、ここに表示されます。');
        if (hasConditions) {
          var reset = node('button', 'nm-retry', '検索・絞り込みを解除');
          reset.type = 'button';
          reset.addEventListener('click', clearConditions);
          message.append(reset);
        }
        container.append(message);
      }
      var cards = scrollMode && shown.length ? wrapCardGrid(container, isCompanies) : container;
      if (isCompanies) {
        var directory = node('div', 'nm-company-directory');
        directory.append(node('p', 'nm-company-directory-intro', 'trends.掲載の同社の発表をもとに、企業ごとの取り組みをテーマと時系列で紹介します。'), cards);
        panel.replaceChildren(directory);
      } else panel.replaceChildren(cards);
      if (pageCount > 1) panel.append(pagination(pageCount));
      if (isNews) panel.prepend(newsScope());
      addPanelHeading();
      panel.setAttribute('aria-busy', 'false');
    }

    function newsScope() {
      var scope = node('div', 'nm-news-scope');
      scope.append(node('p', '', 'この一覧は取得済みの最新' + data.news.length + '件です。検索・絞り込みはこの範囲が対象です。'));
      var links = node('div', 'nm-news-more');
      function destination(path, label, query) {
        var link = node('a', '', label);
        var url = new URL(path, window.location.origin);
        if (query) { url.searchParams.set('type', 'article'); url.searchParams.set('q', query); }
        var theme = new URLSearchParams(window.location.search).get('preview_theme_id') || previewThemeId;
        if (/^\d+$/.test(theme || '')) url.searchParams.set('preview_theme_id', theme);
        link.href = url.href;
        return link;
      }
      links.append(destination('/blogs/media/tagged/itnews', '過去のニュースを探す →'));
      if (state.query) links.append(destination('/search', 'ストアの記事全体を検索 →', state.query));
      scope.append(links);
      return scope;
    }

    function addPanelHeading() {
      if (!config.pageHeading) return;
      var labels = { series: 'すべての特集', companies: '企業から探す', ai: 'AI・業務活用', development: '技術・開発', business: '経営・マーケティング', news: '最新ニュース' };
      panel.prepend(node('h2', 'nm-sr-only nm-panel-heading', labels[state.tab] || 'ニュース特集'));
    }

    function pagination(pageCount) {
      var navigation = node('nav', 'nm-pagination');
      navigation.setAttribute('aria-label', '一覧のページ');
      function pageLink(number, label) {
        var link = node('a', 'nm-page-link', label);
        link.href = routeUrl(state.tab, '', '', number);
        if (number === state.page) link.setAttribute('aria-current', 'page');
        followLocalLink(link, function () {
          state.page = number;
          state.featureId = '';
          render();
          writeHistory('push', routeUrl(state.tab, '', '', number));
          focusAndScroll(panel);
          track('page_select', { page: number });
        });
        return link;
      }
      if (state.page > 1) navigation.append(pageLink(state.page - 1, '← 前へ'));
      var pages = Array.from(new Set([1, state.page - 1, state.page, state.page + 1, pageCount])).filter(function (number) { return number >= 1 && number <= pageCount; }).sort(function (a, b) { return a - b; });
      pages.forEach(function (number, index) {
        if (index && pages[index - 1] < number - 1) navigation.append(node('span', 'nm-page-gap', '…'));
        navigation.append(pageLink(number, String(number)));
      });
      if (state.page < pageCount) navigation.append(pageLink(state.page + 1, '次へ →'));
      return navigation;
    }

    function selectTab(tab) {
      if (!state.ready || tab.hidden) return;
      navigate(tab.dataset.nmTab, '', '', { focus: false });
    }

    function updateSearch() {
      if (!state.ready) return;
      var wasDetail = Boolean(state.companyId);
      if (wasDetail) writeHistory('replace');
      state.companyId = '';
      state.featureId = '';
      state.page = 1;
      setSearchValue(searchInput.value);
      renderRoute();
      writeHistory(wasDetail ? 'push' : 'replace', routeUrl(state.tab, '', ''));
      window.clearTimeout(analyticsTimer);
      analyticsTimer = window.setTimeout(function () {
        var total = Number(panel.dataset.nmResultTotal) || 0;
        track('search', { result_count: total });
        if (!total) track('empty_results');
      }, 600);
    }

    async function load() {
      state.ready = false;
      tabs.forEach(function (tab) { tab.disabled = true; });
      searchInput.disabled = true;
      panel.setAttribute('aria-busy', 'true');
      resultCount.textContent = config.showNews === false ? '特集を読み込んでいます' : 'ニュースを読み込んでいます';
      try {
        var payload;
        if (config.dataSource === 'shop') {
          payload = config.archive || { series: [], news: [] };
          if (typeof payload === 'string') payload = JSON.parse(payload);
        } else {
          var response = await fetch(config.assetUrl, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('News feed could not be loaded');
          payload = await response.json();
        }
        if (Array.isArray(payload)) payload = { series: payload, news: [] };
        if (!payload || typeof payload !== 'object' || (!Array.isArray(payload.series) && !Array.isArray(payload.items) && !Array.isArray(payload.news) && !Array.isArray(payload.companies))) {
          throw new Error('News feed has an invalid format');
        }
        var publishedProjection = config.homeShowcase && Object.prototype.hasOwnProperty.call(payload, 'published_archive');
        if (publishedProjection) {
          var projection = payload.published_archive;
          if (!projection || projection.version !== 1 || !/^[a-f0-9]{64}$/.test(projection.revision || '') || !Array.isArray(projection.series) || !Array.isArray(projection.companies)) throw new Error('Published homepage index has an invalid format');
          var ranks = new Set(), articleIds = new Set();
          projection.series.concat(projection.companies).forEach(function (item) {
            if (!item || item.published !== true || typeof item.title !== 'string' || !Number.isInteger(item.archive_order) || item.archive_order < 0 || ranks.has(item.archive_order) || !/^gid:\/\/shopify\/Article\/\d+$/.test(item.article_id || '') || articleIds.has(item.article_id)) throw new Error('Published homepage identity is invalid');
            ranks.add(item.archive_order); articleIds.add(item.article_id);
          });
          // The original arrays continue to serve legacy editorial/review views.
          // Only the homepage uses the API-confirmed public archive projection.
          payload = Object.assign({}, payload, { series: projection.series, companies: projection.companies, news: [] });
          section.dataset.nmArchiveRevision = projection.revision;
        }
        function validItems(items) {
          var valid = (Array.isArray(items) ? items : []).filter(function (item) { return item && typeof item === 'object' && typeof item.title === 'string'; });
          valid.forEach(function (item) {
            var members = Array.isArray(item.members) ? item.members : [];
            var text = [item.title, item.description].concat(members.map(function (member) { return member && member.title; }));
            searchIndex.set(item, text.map(normaliseSearch).join(' '));
          });
          return sortNewest(valid);
        }
        data.series = validItems(payload.series || payload.items);
        data.news = validItems(payload.news);
        data.companies = (Array.isArray(payload.companies) ? payload.companies : []).filter(function (company) {
          return company && typeof company === 'object' && typeof company.id === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(company.id) && typeof company.title === 'string' && (typeof company.name === 'string' || typeof company.legal_name === 'string');
        }).map(function (company) {
          var members = (Array.isArray(company.members) ? company.members : []).filter(function (member) { return member && typeof member === 'object' && typeof member.title === 'string'; });
          var item = Object.assign({}, company, { members: members });
          var text = [item.name, item.legal_name, item.title, item.description];
          ['aliases', 'products', 'topics'].forEach(function (key) { if (Array.isArray(item[key])) text = text.concat(item[key]); });
          text = text.concat(members.map(function (member) { return member.title; }));
          searchIndex.set(item, text.map(normaliseSearch).join(' '));
          return item;
        }).sort(function (a, b) { return latestCompanyTime(b) - latestCompanyTime(a) || a.id.localeCompare(b.id, 'en'); });
        if (publishedProjection) {
          data.series.sort(function (a, b) { return a.archive_order - b.archive_order; });
          data.companies.sort(function (a, b) { return a.archive_order - b.archive_order; });
        }
        var requestedPreview = String(payload.preview_theme_id || '');
        // 公開テーマではデータ由来のプレビュー指定を使わない（robots.txt が preview_theme_id を Disallow しているため）。
        previewThemeId = config.dataSource === 'preview' && config.themeRole === 'unpublished' && /^\d+$/.test(requestedPreview) ? requestedPreview : '';
        config.previewThemeId = previewThemeId;
        state.ready = true;
        searchInput.disabled = false;
        var updated = formatDate(payload.generated_at);
        section.querySelector('[data-nm-updated]').textContent = updated ? '更新 ' + updated : '';
        restoreLocation(false);
        if (peek) peek.syncFromUrl();
      } catch (_) {
        state.ready = false;
        searchInput.disabled = true;
        tabs.forEach(function (tab) { tab.disabled = true; });
        panel.setAttribute('aria-busy', 'false');
        resultCount.textContent = config.showNews === false ? '特集を読み込めませんでした' : 'ニュースを読み込めませんでした';
        var failure = empty('検索・絞り込みを読み込めませんでした', initialLinks ? '下の一覧から記事をお読みいただけます。再読み込みして絞り込みをお試しください。' : '時間をおいて、もう一度お試しください。', true);
        if (initialLinks) panel.replaceChildren(failure, initialLinks);
        else panel.replaceChildren(failure);
      }
    }

    try {
      config = JSON.parse(section.querySelector('[data-nm-config]').textContent);
    } catch (_) {
      panel.setAttribute('aria-busy', 'false');
      resultCount.textContent = '表示設定を読み込めませんでした';
      var configurationError = empty('検索・絞り込みを利用できません', initialLinks ? '下の一覧から記事をお読みいただけます。' : '時間をおいて、もう一度お試しください。');
      if (initialLinks) panel.replaceChildren(configurationError, initialLinks);
      else panel.replaceChildren(configurationError);
      return;
    }

    if (config.homeShowcase) {
      section.classList.add('nm-showcase');
      var searchRow = section.querySelector('.nm-search-row');
      if (searchRow) searchRow.hidden = true;
      var resultsMeta = section.querySelector('.nm-results-meta');
      if (resultsMeta) resultsMeta.classList.add('nm-sr-only');
    }
    section.querySelectorAll('[data-nm-js-controls]').forEach(function (element) { element.hidden = Boolean(config.homeShowcase && element.classList.contains('nm-search-row')); });
    panel.setAttribute('role', 'tabpanel');
    // カード内のリンクはサイドピークで開く。href は実URLのまま残すのでクローラは記事URLを辿れる。
    // 出典（外部・転載記事）と一覧への導線は対象外。自動実行のクリックでは開かない。
    function peekHandleForLink(link) {
      if (!peek) return '';
      var raw = link.getAttribute('href') || '';
      var direct = peek.handleFromHref(raw);
      if (direct) return direct;
      var url;
      try { url = new URL(raw, window.location.origin); } catch (error) { return ''; }
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return '';
      var companyId = url.searchParams.get('nm_company') || '';
      var featureId = url.searchParams.get('nm_series') || '';
      var item = companyId ? data.companies.find(function (row) { return row.id === companyId; })
        : featureId ? data.series.find(function (row) { return row.id === featureId; }) : null;
      var destination = item && articleDestination(item, config);
      return destination ? peek.handleFromHref(destination) : '';
    }
    section.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link || !section.contains(link)) return;
      if (suppressClick) { event.preventDefault(); return; }
      if (peek && event.isTrusted && !event.defaultPrevented && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        var handle = peekHandleForLink(link);
        if (handle && peek.open(handle, link)) {
          event.preventDefault();
          track(link.dataset.nmArticleKind === 'company' ? 'company_open' : 'series_open', { peek: true });
          return;
        }
      }
      if (link.dataset.nmArticleKind) track(link.dataset.nmArticleKind === 'company' ? 'company_open' : 'series_open');
      else if (link.classList.contains('nm-source-link')) track('source_open');
    });
    // ---------- フリックでタブを切り替える ----------
    // 切り替えたらタブ列まで戻す（下方にスクロールしたままだと切替に気づけないため）。
    var SWIPE_MIN = 55, SWIPE_RATIO = 1.6, SWIPE_MS = 700, DRAG_MIN = 90, WHEEL_MIN = 120, swipeStart = null;
    var SWIPE_EXCLUDE = '.nm-tabs, .nm-search-row, .nm-filters, button, input, select, textarea, details, summary';
    function revealActiveTab() {
      // タブ列は横スクロールなので、切り替えた先が画面外に出たままにならないよう寄せる。
      var strip = section.querySelector('.nm-tabs');
      var active = strip && strip.querySelector('.nm-tab[aria-selected="true"]');
      if (!strip || !active || strip.scrollWidth <= strip.clientWidth) return;
      var target = Math.max(0, active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2);
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { strip.scrollTo({ left: target, behavior: still ? 'auto' : 'smooth' }); }
      catch (error) { strip.scrollLeft = target; }
    }
    function stickyOffset() {
      // 追従ヘッダーがあるとタブ列が隠れるため、その高さぶん手前で止める。
      var found = 0;
      document.querySelectorAll('header, .tds-header, [class*="header"]').forEach(function (element) {
        var style = window.getComputedStyle(element);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;
        var box = element.getBoundingClientRect();
        // いま画面上端を覆っているものだけを追従ヘッダーとみなす。スクロールで流れ去る
        // sticky ヘッダーを固定扱いにすると、余白だけが残ってしまう。
        if (box.height && box.top <= 1 && box.bottom > 1) found = Math.max(found, box.bottom);
      });
      return Math.min(found, 160) + 12;
    }
    var stickyFrame = null, stickyValue = null;
    function requestStickySync() {
      if (stickyFrame) return;
      stickyFrame = requestAnimationFrame(function () { stickyFrame = null; syncStickyTop(); });
    }
    function syncStickyTop() {
      // タブ行は position:sticky。追従ヘッダーの下で止まるよう、その高さを変数へ入れる。
      var value = Math.max(0, stickyOffset() - 12);
      if (value === stickyValue) return;
      stickyValue = value;
      document.documentElement.style.setProperty('--nm-sticky-top', value + 'px');
    }
    function scrollToTabs() {
      var target = section.querySelector('.nm-tabs') || section;
      var top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - stickyOffset());
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { window.scrollTo({ top: top, behavior: still ? 'auto' : 'smooth' }); }
      catch (error) { window.scrollTo(0, top); }
    }
    function swipeTabs(step) {
      var available = visibleTabs();
      if (!state.ready || available.length < 2 || (peek && peek.isOpen())) return;
      var index = available.findIndex(function (tab) { return tab.dataset.nmTab === state.tab; });
      if (index < 0) return;
      var target = available[(index + step + available.length) % available.length];
      if (showcaseStage) showcaseStage.style.setProperty('--nm-carousel-direction', (step * 18) + 'px');
      navigate(target.dataset.nmTab, '', '', { focus: false, clearSearch: true });
      track('showcase_change');
      scrollToTabs();
      revealActiveTab();
    }
    section.addEventListener('touchstart', function (event) {
      swipeStart = null;
      if (event.touches.length !== 1 || !state.ready || (peek && peek.isOpen())) return;
      if (event.target.closest(SWIPE_EXCLUDE)) return;
      var touch = event.touches[0];
      // iOS の画面端スワイプ（戻る操作）と二重発火しないよう、端24pxからの開始は無視する。
      if (touch.clientX <= 24 || touch.clientX >= window.innerWidth - 24) return;
      swipeStart = { x: touch.clientX, y: touch.clientY, at: Date.now() };
    }, { passive: true });
    section.addEventListener('touchend', function (event) {
      var start = swipeStart;
      swipeStart = null;
      if (!start || !event.changedTouches.length || Date.now() - start.at > SWIPE_MS) return;
      var touch = event.changedTouches[0], dx = touch.clientX - start.x, dy = touch.clientY - start.y;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * SWIPE_RATIO) return;
      swipeTabs(dx < 0 ? 1 : -1);
    }, { passive: true });
    section.addEventListener('touchcancel', function () { swipeStart = null; }, { passive: true });
    // トラックパッドの横スクロール（および Shift+ホイール）でも切り替える。
    var wheelDelta = 0, wheelTimer = null, wheelLock = false;
    section.addEventListener('wheel', function (event) {
      if (!state.ready || (peek && peek.isOpen())) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      if (event.target.closest('.nm-tabs, .nm-search-row, .nm-filters, [data-nm-card-scroll], input, textarea, select')) return;
      event.preventDefault();
      if (wheelLock) return;
      wheelDelta += event.deltaX;
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function () { wheelDelta = 0; }, 220);
      if (Math.abs(wheelDelta) < WHEEL_MIN) return;
      var direction = wheelDelta > 0 ? 1 : -1;
      wheelDelta = 0;
      wheelLock = true;
      setTimeout(function () { wheelLock = false; }, 700);
      swipeTabs(direction);
    }, { passive: false });

    // PCではドラッグ（マウス・ペン）でも切り替える。タッチは上の touch* が担当する。
    var drag = null, suppressClick = false;
    function dragTarget(event) { return event.target.closest ? event.target.closest(SWIPE_EXCLUDE) : null; }
    section.addEventListener('pointerdown', function (event) {
      drag = null;
      if (event.pointerType === 'touch' || event.button !== 0 || !state.ready || (peek && peek.isOpen())) return;
      if (dragTarget(event)) return;
      if (event.clientX <= 24 || event.clientX >= window.innerWidth - 24) return;
      drag = { x: event.clientX, y: event.clientY, at: Date.now(), moved: false };
    });
    section.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var dx = event.clientX - drag.x, dy = event.clientY - drag.y;
      if (!drag.moved && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) drag.moved = true;
      // 横へ動かし始めたら、文字選択とリンクのドラッグ開始を抑える。
      if (drag.moved) event.preventDefault();
    }, { passive: false });
    section.addEventListener('pointerup', function (event) {
      var start = drag;
      drag = null;
      if (!start || !start.moved || Date.now() - start.at > 900) return;
      var dx = event.clientX - start.x, dy = event.clientY - start.y;
      if (Math.abs(dx) < DRAG_MIN || Math.abs(dx) < Math.abs(dy) * SWIPE_RATIO) return;
      // 直後の click でピークが開かないよう、この1回だけ握りつぶす。
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 0);
      swipeTabs(dx < 0 ? 1 : -1);
    });
    section.addEventListener('pointercancel', function () { drag = null; });
    section.addEventListener('dragstart', function (event) { if (drag) event.preventDefault(); });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { selectTab(tab); });
      tab.addEventListener('keydown', function (event) {
        var available = visibleTabs();
        var index = available.indexOf(tab);
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % available.length;
        if (event.key === 'ArrowLeft') next = (index + available.length - 1) % available.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = available.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        available[next].focus({ preventScroll: true });
        selectTab(available[next]);
      });
    });
    searchInput.addEventListener('compositionstart', function () { composing = true; });
    searchInput.addEventListener('compositionend', function () { composing = false; updateSearch(); });
    searchInput.addEventListener('input', function (event) { if (!composing && !event.isComposing) updateSearch(); });
    searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !composing) {
        event.preventDefault();
        searchInput.value = '';
        updateSearch();
      }
    });
    searchClear.addEventListener('click', function () {
      searchInput.value = '';
      updateSearch();
      searchInput.focus({ preventScroll: true });
    });
    syncStickyTop();
    window.addEventListener('load', syncStickyTop);
    window.addEventListener('scroll', requestStickySync, { passive: true });
    window.addEventListener('resize', function () { scheduleCardScroll(); syncStickyTop(); });
    window.addEventListener('popstate', function () {
      if (!section.isConnected || !state.ready) return;
      var params = new URLSearchParams(window.location.search);
      var tab = params.get('nm_tab') || 'series';
      var companyId = tab === 'companies' ? params.get('nm_company') || '' : '';
      var featureId = tab === 'series' ? params.get('nm_series') || '' : '';
      var historyState = window.history.state;
      var saved = historyState && historyState.newsMatome && historyState.newsMatome[config.sectionId];
      // A normal article footnote can change only the URL fragment. Do not
      // rebuild the article or steal focus when its route is unchanged.
      var query = params.has('q') ? params.get('q').slice(0, 160).trim() : saved ? saved.query : '';
      var category = params.has('category') ? params.get('category').slice(0, 120) : saved ? saved.category : '';
      var page = Number(params.get('nm_page')) || (saved && saved.page) || 1;
      if (tab === state.tab && companyId === state.companyId && featureId === state.featureId && query === state.query && category === state.category && page === state.page) return;
      restoreLocation(true);
    });
    section.querySelectorAll('[data-nm-archive]').forEach(function (link) {
      link.dataset.nmArchiveBase = link.getAttribute('href');
      var href = previewUrl(link.getAttribute('href'));
      if (href) link.href = href;
    });
    load();
  }

  function boot(scope) {
    scope.querySelectorAll('[data-news-matome]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  if (!window.__newsMatomeSectionListener) {
    window.__newsMatomeSectionListener = true;
    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  }
}());
